import { Component, OnInit } from '@angular/core';
import { SharedService } from '../Sharedservice/SharedService';
import { IPatientSearch } from '../models/IPatientSearch.model';
import { DatePipe } from '@angular/common';
import { PatientBannerService } from './patient-banner.service';
import { CommonComponents } from '../Sharedservice/CommonComponents';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patient-banner',
  templateUrl: './patient-banner.component.html',
  styleUrls: ['./patient-banner.component.css']
})
export class PatientBannerComponent implements OnInit {
  isBanner: boolean = false;
  patientId: number;
  dPatientId: number;
  patGender: string;
  PatName: string;
  patDOB: string;
  displaydate: string;
  patientInfo: IPatientSearch;
  IsDateDiv: boolean = false;
  patAge: string = '';
  primaryPayerName: string;
  constructor(private sharedService: SharedService, private datePipe: DatePipe, private route: Router,
    private bannerService: PatientBannerService) {
    this.getSystem();
    this.id = Number(sessionStorage.getItem("patientId"));
    CommonComponents.patientId = this.id;

    this.getPatientInfo(this.id);

  }
  getSystem() {
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("patientAge") != null || sessionStorage.getItem("patientAge") != undefined) {
      CommonComponents.patientAge = sessionStorage.getItem("patientAge");
    }
    if (sessionStorage.getItem("patientGender") != null || sessionStorage.getItem("patientGender") != undefined) {
      CommonComponents.patientGender = sessionStorage.getItem("patientGender");
    }


  }
  id: number;
  ngOnInit() {
    //this.id=Number(sessionStorage.getItem("patientId"));
    //this.getPatientInfo(this.id);
    this.bannerService.patientBanner.subscribe(patId => {
      if (patId == 0 || patId == undefined || patId == null) {
        this.id = Number(sessionStorage.getItem("patientId"));
        CommonComponents.patientId = this.id;
      }
      this.id = patId;
      this.getPatientInfo(this.id);
    });



    this.bannerService.patBanHide.subscribe(isban => {
      this.isBanner = isban;

    })
  }

  async getPatientInfo(id) {
    ;
    if (id > 0) {
      await this.sharedService.getPatientInfo(id)
        .subscribe(
          (personal: IPatientSearch) => {
            this.patientInfo = personal[0];
            this.isBanner = true;
            this.patientId = this.patientInfo.patientId;
            this.dPatientId = this.patientInfo.dPatId;
            this.patGender = this.patientInfo.gender;
            this.PatName = this.patientInfo.name;
            this.patDOB = this.datePipe.transform(this.patientInfo.dob, "MM/dd/yyyy");
            this.primaryPayerName = this.patientInfo.insurenceName === null ? '' : this.patientInfo.insurenceName;
            CommonComponents.patientName = this.PatName;
            CommonComponents.patientGender = this.patGender;

            sessionStorage.setItem("DPatId", this.dPatientId.toString());
            if ((sessionStorage.getItem("displayappDate") != null || sessionStorage.getItem("displayappDate") != undefined) && sessionStorage.getItem("displayappDate") != "null") {
              this.IsDateDiv = true;
              this.displaydate = this.datePipe.transform(sessionStorage.getItem("displayappDate"), "MM/dd/yyyy");
            }
            else {
              this.IsDateDiv = false;
            }

            if (this.IsDateDiv === false) {
              if ((sessionStorage.getItem("displayappDate1") != null || sessionStorage.getItem("displayappDate1") != undefined)
                && sessionStorage.getItem("displayappDate1") != 'null') {
                this.IsDateDiv = true;
                this.displaydate = this.datePipe.transform(sessionStorage.getItem("displayappDate1"), "MM/dd/yyyy");
              }
              else {
                this.IsDateDiv = false;
              }
            }


            var _age = "0";
            if (this.patDOB != '') {
              //convert date again to type Date
              // const bdate = new Date(this.patDOB);
              // const timeDiff = Math.abs(Date.now() - bdate.getTime());
              // _age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
              var birthdate = new Date(this.patDOB);
              var todayDate = new Date();
              var ageyear = todayDate.getFullYear() - birthdate.getFullYear();
              var agemonth = todayDate.getMonth() - birthdate.getMonth();
              var ageday = todayDate.getDate() - birthdate.getDate();

              var nowDay = todayDate.getDate();
              var dobDay = birthdate.getDate();

              if (agemonth <= 0) {
                ageyear--;
                agemonth = (12 + agemonth);
              }
              if (nowDay < dobDay) {
                agemonth--;
                ageday = 30 + ageday;
              } if (agemonth == 12) {
                ageyear = ageyear + 1;
                agemonth = 0;
              }

              if (ageyear != 0) {
                _age = ageyear + ' Y';
              } else if (agemonth <= 11 && agemonth > 0) {
                _age = agemonth + ' M';
              } else {
                _age = ageday + ' D';
              }
              CommonComponents.patientAge = _age.toString();
              this.patAge = _age;
            } else {
              this.patAge = _age + ' D';
            }

          },
          (err: any) => console.log(err)
        );
    } else {
      this.isBanner = false;
    }
  }

}
